import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/cars_groups_settings/')({
  beforeLoad: () => ({
    documentTitle: { main: 'carsGroups.carsGroups', suffix: 'menu.settings' },
  }),
  component: () => null,
});
